import {
  DO_FETCH_HARVEST_BUDGET,
  DO_FETCH_HARVEST_PROJECTS,
  DO_FETCH_HARVEST_USERS,
  FAIL_HARVEST_BUDGET,
  FAIL_HARVEST_PROJECTS,
  FAIL_HARVEST_USERS,
  HarvestAction,
  HarvestState,
  LOAD_HARVEST_BUDGET,
  LOAD_HARVEST_PROJECTS,
  LOAD_HARVEST_USERS
} from "./HarvestTypes";
import {
  failedStatus,
  idleLoadStatus,
  loadingStatus,
  succeededStatus,
} from "../redux/LoadStatus";

const initialState: HarvestState = {
  synching: {},
  projects: [],
  projectsStatus: idleLoadStatus,
  users: {
    synching: false,
    status: idleLoadStatus,
    items: [],
  },
  budgetStatus: {},
  budgets: {},
};

export default function harvestReducer(
  state = initialState,
  action: HarvestAction
): HarvestState {
  switch (action.type) {
    case LOAD_HARVEST_PROJECTS: {
      return {
        ...state,
        projects: action.projects,
        projectsStatus: succeededStatus(action.loadedAt),
      };
    }
    case DO_FETCH_HARVEST_PROJECTS: {
      return {
        ...state,
        projectsStatus: loadingStatus(),
      };
    }
    case FAIL_HARVEST_PROJECTS: {
      return {
        ...state,
        projectsStatus: failedStatus(action.error),
      };
    }
    case DO_FETCH_HARVEST_USERS: {
      return {
        ...state,
        users: {
          synching: true,
          status: loadingStatus(),
          items: state.users.items,
        },
      };
    }
    case LOAD_HARVEST_USERS: {
      return {
        ...state,
        users: {
          synching: false,
          status: succeededStatus(action.loadedAt),
          items: action.items,
        },
      };
    }
    case FAIL_HARVEST_USERS: {
      return {
        ...state,
        users: {
          synching: false,
          status: failedStatus(action.error),
          items: state.users.items,
        },
      };
    }
    case DO_FETCH_HARVEST_BUDGET: {
      const key = `${action.year}-${action.month}`;
      const currentValue = state.synching[key];
      if (currentValue !== true) {
        return {
          ...state,
          synching: {
            ...state.synching,
            [key]: true,
          },
          budgetStatus: {
            ...state.budgetStatus,
            [key]: loadingStatus(),
          },
        };
      } else {
        return state;
      }
    }
    case LOAD_HARVEST_BUDGET: {
      const key = `${action.year}-${action.month}`;
      const synching = { ...state.synching };
      delete synching[key];
      const newState = {
        ...state,
        synching,
        budgetStatus: {
          ...state.budgetStatus,
          [key]: succeededStatus(action.loadedAt),
        },
      };
      // update only if budget changed
      if (newState?.budgets?.[action.year]?.[action.month] !== action.budget) {
        newState.budgets = { ...state.budgets };
        if (newState.budgets[`${action.year}`]) {
          const year = newState.budgets[`${action.year}`];
          newState.budgets[`${action.year}`] = { ...year };
        } else {
          newState.budgets[action.year] = {};
        }
        newState.budgets[action.year][action.month] = action.budget;
      }
      return newState;
    }
    case FAIL_HARVEST_BUDGET: {
      const key = `${action.year}-${action.month}`;
      const synching = { ...state.synching };
      delete synching[key];
      return {
        ...state,
        synching,
        budgetStatus: {
          ...state.budgetStatus,
          [key]: failedStatus(action.error),
        },
      };
    }
    default:
      return state;
  }
}
